export const grabAndGo = {
	activeProducts: "Active products for Grab and Go",
	disabledProducts: "Deactivated products for Grab and Go",
	searchPlaceholder: "Filter products",
};
